import React from 'react';

export default function Breadcrumbs({ parts, onNavigate }) {
  return (
    <nav className="mol-breadcrumbs">
      <button className="mol-breadcrumbs__item" onClick={() => onNavigate('')}>
        Home
      </button>
      {parts.map((part, i) => {
        const path = parts.slice(0, i + 1).join('/') + '/';
        const isLast = i === parts.length - 1;
        return (
          <React.Fragment key={i}>
            <span className="mol-breadcrumbs__sep">/</span>
            {isLast ? (
              <span className="mol-breadcrumbs__item mol-breadcrumbs__item--active">{part}</span>
            ) : (
              <button className="mol-breadcrumbs__item" onClick={() => onNavigate(path)}>
                {part}
              </button>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
